<template >
  <div class="">
    <div class="child flex items-center ml-12 pl-4 mr-2 h-8 group truncate link-name group-parent-bold ml-1 border-solid rounded mt-1"
      :class="{'color-link-disabled': item.warning === 2}"
      >
         <el-tooltip :open-delay="600" placement="right">
            <div slot="content">                    
              <div class="max-w-sm max-h-500p overflow-auto">                  
                  <div>
                    {{ title }}
                  </div>                  
              </div>
            </div>
            <span class="truncate">
              {{ title }}
              <span v-if="item.warning === 3" class="k-icon k-i-warning color-warning ml-1 pr-1"/>
            </span>
          </el-tooltip>   
      <span
      @click.prevent="toggleGroup"
      class="arrow ml-auto w-8 h-7 flex-none flex items-center justify-center cursor-pointer hover:bg-primary-200 dark:hover:bg-darkblue-600  rounded animate-hover"
      >
        <span
          :class="{ 'rotate-180': activeGroup }"
          class="flex-shrink-0 px-2 transform transition-transform duration-300 dark:text-darkblue-400 dark:hover:text-primary">
          <base-icon name="chevrondown" size="sm" />
        </span>
      </span>
    </div>
      <transition
        name="list-links"
        @enter="startTransition"
        @after-enter="endTransition"
        @before-leave="startTransition"
        @after-leave="endTransition"
      >
        <div v-show="activeGroup" 
            class="relative group-container">
          <base-aside-nav-item-link 
            v-for="link in item.sc" :key="link.name"  
            :link="link"
            />
        </div>
      </transition>
  </div>
</template>

<script>
export default {
  name: 'aside-nav-item-group',
  props: {
    item: {
      type: [Object, Array],
      required: true
    },
    title: {
      type: String,
      default: 'Cabecera'
    }
  },
  data: function () {
    return {
      activeGroup: true,
    }
  },
  created () {
    this.activeGroup = this.itemMenuState
  },
  computed: {
    menuState () {
      return this.$store.getters['app/menuState']
    },
    itemMenuState () {
      if (Object.hasOwnProperty.call(this.menuState, this.item?.menuId)) {
        return !!this.menuState[this.item?.menuId]
      }
      return this.item.desplegado
    }
  },
  methods: {
    toggleGroup: function () {
      this.activeGroup = !this.activeGroup
      this.item.desplegado = this.activeGroup
      if (Object.hasOwnProperty.call(this.menuState, this.item?.menuId)) {
        const payload = { menuId: this.item?.menuId, active: this.activeGroup }
        this.$store.dispatch('app/setMenuState', payload)
      }
    },
    startTransition: function (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition: function (el) {
      el.style.height = ''
    }
  }
}
</script>

<style lang="scss" scoped>
a.parent {
  @apply pl-4 pr-5;
}
[data-type='main'] {
  a.parent {
    @apply pl-3 pr-1;
  }
}
a.child {
  @apply pl-12;
}
.group-container{
  @apply bg-primary-50;
  @apply dark:bg-darkblue;
}
[data-type='main'] {
  a.child {
    @apply pl-11;
  }
  div.child {
    @apply pl-4;
    @apply ml-8;
  }
  .group-container{
    @apply bg-white;
    @apply dark:bg-darkblue-900;
  }
}

.animate-hover {
  @apply transition-colors duration-300;
}
.animate-all {
  @apply transition-all duration-300;
}
.cover-subnav {
  @apply border-secondary-100;
}
.span-nav-link-container{
  @apply border-secondary-200;
}
.link-icon {
  @apply text-secondary-500 dark:text-darkblue-400;
}
.link-name {
    @apply text-secondary dark:text-darkblue-200 font-medium;
  }
.link-name.color-link-disabled{
  @apply text-secondary-300;
}
.dark .link-name.color-link-disabled{
  @apply text-secondary-600;
}
.router-link-active {
  .link-icon {
    @apply text-secondary dark:text-darkblue-200;
  }
  .link-name {
    @apply text-secondary-800 dark:text-darkblue-100 font-bold;
  }
  .color-link-disabled{
    @apply text-secondary-800;
  }
  .cover-subnav {
    @apply border-primary;
  }
  .span-nav-link-container{
    @apply border-primary;
  }
}
.rotate-180 {
  transform: rotate(-180deg);
}
.list-links-enter-active,
.list-links-leave-active {
  will-change: height;
  transition: height 0.2s ease-out;
}
.list-links-enter,
.list-links-leave-to {
  height: 0 !important;
}
</style>
